import { create } from 'zustand';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  toolsUsed?: string[];
  pending?: boolean;
}

interface ChatState {
  open: boolean;
  messages: ChatMessage[];
  streaming: boolean;
  toggle: () => void;
  setOpen: (v: boolean) => void;
  pushUser: (content: string) => void;
  startAssistant: () => void;
  appendAssistant: (token: string) => void;
  finishAssistant: (toolsUsed?: string[]) => void;
  setError: (msg: string) => void;
  reset: () => void;
}

export const useChatStore = create<ChatState>((set) => ({
  open: false,
  messages: [],
  streaming: false,
  toggle: () => set((s) => ({ open: !s.open })),
  setOpen: (v) => set({ open: v }),
  pushUser: (content) =>
    set((s) => ({ messages: [...s.messages, { role: 'user', content }] })),
  startAssistant: () =>
    set((s) => ({
      streaming: true,
      messages: [...s.messages, { role: 'assistant', content: '', pending: true }],
    })),
  appendAssistant: (token) =>
    set((s) => {
      const last = s.messages[s.messages.length - 1];
      if (!last || last.role !== 'assistant') return s;
      const updated: ChatMessage = { ...last, content: last.content + token };
      return { messages: [...s.messages.slice(0, -1), updated] };
    }),
  finishAssistant: (toolsUsed) =>
    set((s) => {
      const last = s.messages[s.messages.length - 1];
      if (!last || last.role !== 'assistant') return { streaming: false };
      const updated: ChatMessage = { ...last, pending: false, toolsUsed };
      return { messages: [...s.messages.slice(0, -1), updated], streaming: false };
    }),
  setError: (msg) =>
    set((s) => {
      const last = s.messages[s.messages.length - 1];
      if (last && last.role === 'assistant' && last.pending) {
        const updated: ChatMessage = { ...last, content: msg, pending: false };
        return { messages: [...s.messages.slice(0, -1), updated], streaming: false };
      }
      return {
        messages: [...s.messages, { role: 'assistant', content: msg }],
        streaming: false,
      };
    }),
  reset: () => set({ messages: [], streaming: false }),
}));
